function loadStyles() {
  document.querySelectorAll("[data-style-src]").forEach((style) => {
    const src = style.dataset.styleSrc;
    const styleEl = document.createElement("link");
    styleEl.rel = "stylesheet";
    styleEl.href = src;
    document.head.appendChild(styleEl);
  });
}

function loadScripts() {
  document.querySelectorAll("[data-script-src]").forEach((script) => {
    const src = script.dataset.scriptSrc;
    const scriptEl = document.createElement("script");
    scriptEl.src = src;
    scriptEl.defer = true;
    document.head.appendChild(scriptEl);
  });
}

function loadAssets() {
  loadStyles();
  loadScripts();
}

loadAssets();

const quantityBreaks = document.querySelectorAll(".quantity-break");
const totalPrices = document.querySelectorAll(".quantity-breaks-total-price");

quantityBreaks.forEach((b) => {
  b.addEventListener("click", () => {
    const quantity = b.dataset.quantityBreak;

    totalPrices.forEach((price) => price.classList.add("hidden"));

    const matchingPrice = document.querySelector(
      `.quantity-breaks-total-price[data-quantity-break="${quantity}"]`
    );
    if (matchingPrice) {
      matchingPrice.classList.remove("hidden");
    }
  });
});

class CustomSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.learnMore = this.querySelector("[data-open-popup]");
    this.subscriptionPopupWrapper = this.querySelector(
      "[data-subscription-popup-wrapper]"
    );
    this.closePopup = this.querySelector("[data-close-popup]");
    this.oneTimeCard = this.querySelector('[data-option="onetime"]');
    this.subscriptionCard = this.querySelector('[data-option="subscribe"]');
    this.subscriptionDetails = this.querySelector(".subscription-details");
    this.subscriptionCard.addEventListener(
      "click",
      this.handleSubscriptionCardClick.bind(this)
    );
    this.oneTimeCard.addEventListener(
      "click",
      this.handleOneTimeCardClick.bind(this)
    );
    this.learnMore.addEventListener(
      "click",
      this.handleLearnMoreClick.bind(this)
    );
    this.closePopup.addEventListener(
      "click",
      this.handleClosePopupClick.bind(this)
    );
    this.subscriptionPopupWrapper.addEventListener(
      "click",
      this.handleClosePopupClick.bind(this)
    );
  }

  handleSubscriptionCardClick() {
    this.subscriptionDetails.classList.remove("hidden");

    const hasCheckedPlan = this.querySelector(".plan-card input:checked");
    if (!hasCheckedPlan) {
      const firstPlanInput = this.querySelector(".plan-card input");
      if (firstPlanInput) {
        firstPlanInput.checked = true;
      }
    }
  }

  handleLearnMoreClick() {
    this.subscriptionPopupWrapper.classList.add("show");
  }

  handleOneTimeCardClick() {
    this.subscriptionDetails.classList.add("hidden");
    this.oneTimeCard.querySelector("input").checked = true;
  }

  handleClosePopupClick() {
    this.subscriptionPopupWrapper.classList.remove("show");
  }
}

customElements.define("custom-subscription-widget", CustomSubscriptionWidget);
